import React from 'react'
import "./BigOrangeButton.css"
import { useNavigate } from "react-router-dom";

export default function BigOrangeButton(props) {
  const navigate = useNavigate();
  const NavTo = () => {
    navigate(props.location)
  }

  return (
    <div className='big-orange-btn__container'>
      <button onClick={NavTo} className="big-orange-btn__btn">{ props.text }</button>
    </div>
  )
}
